import Vue from 'vue';
import axios from 'axios';

const EventBus = new Vue({
  data() {
    return {
      inventory: [],
      ufInventory: [],
      options: {},
      requestInventoryCallbacks: [],
      requestInventoryStatus: 'WAITING_REQUEST',
      usedFinancing: [],
      doPayments: false,
      vehicleMatcher: {
        vehicle: null,
      }
    }
  },
  created() {
    window.addEventListener("load", this.onWindowLoad);
  },
  methods: {
    onWindowLoad() {
        var ts = Date.now();

        var url = window.location.href;
        if (!url.includes('local')) {
          axios.get('/wp-content/themes/base/resources/assets/styles/build/mix-manifest.json?v='+ts)
          .then(response => {
            document.getElementById('child-theme-styles-css').href = "/wp-content/themes/base/resources/assets/styles/build/"+response.data['/dealer.css'];
            document.getElementById('preload-child-css').href = "/wp-content/themes/base/resources/assets/styles/build/"+response.data['/dealer.css'];
          })
          .catch(() => {
          });
        }
    },
    getUsedFinance() {
      return new Promise((resolve, reject) => {
        wp.ajax.post("get_used_finance", {})
          .done((response) => {
            this.usedFinancing = JSON.parse(response);
            resolve();
          })
          .fail(() => {
            this.usedFinancing = JSON.parse("");
            reject();
          });
      });
    },
    findDoPayments() {
      return new Promise((resolve, reject) => {
        wp.ajax.post("do_payments", {})
          .done((response) => {
            this.doPayments = JSON.parse(response);
            resolve();
          })
          .fail(() => {
            this.doPayments = JSON.parse("");
            reject();
          });
      });
    },
    tryGetFormSubmission() {
      wp.ajax.post("get_leadbox_ninja_forms_after_submission")
        .done((response) => {})
        .fail(() => {})
    },
    tryGetInventoryFrom(target, callback, params) {
      wp.ajax.post("get_leadbox_inventory_from_" + target, { 'params': params })
        .done((response) => {
          this.inventory = JSON.parse(response);
          callback(true);
        })
        .fail(() => {
          callback(false);
        })
    },
    httpRequestInventory(contentdir, callback, gutembergOptions) {
      switch (this.requestInventoryStatus) {
        case "WAITING_REQUEST": {
          this.requestInventoryStatus = "REQUESTING_INVENTORY";
          let setPayments = localStorage.getItem("lbx_setPayments");
    
          this.getUnfilteredInventory(this)
            .then((unfilteredInventory) => {
              this.inventory = unfilteredInventory;
              this.ufInventory = unfilteredInventory;
    
              // Retornar la promesa de findDoPayments
              return this.findDoPayments().then((success) => {
                if (this.inventory.length > 0 && !setPayments && this.doPayments) {
                  // Retornar la promesa de getUsedFinance y setPayments
                  return this.getUsedFinance().then(() => this.setPayments());
                } else {
                  return this.inventory; // Retornar inventory como promesa resuelta
                }
              });
            })
            .then((success) => {
              if (success) {
                this.inventory = success;
              }
    
              this.options = gutembergOptions;
              this.gutembergOptionsFiltering();
              this.requestInventoryStatus = "REQUEST_SUCCESSFULLY_COMPLETED";
              
              const inventoryData = JSON.parse(JSON.stringify(this.inventory));
              callback(inventoryData);
            })
            .catch((error) => {
              this.requestInventoryStatus = "REQUEST_FAILED";
              callback([]);
            })
            .finally(() => {
              this.sendRemainingCallbacks(this.ufInventory);
            });
          break;
        }
        case "REQUESTING_INVENTORY":
          this.requestInventoryCallbacks.push({ callback, gutembergOptions });
          break;
        case "REQUEST_SUCCESSFULLY_COMPLETED": {
          const inventoryData = JSON.parse(JSON.stringify(this.inventory));
          callback(inventoryData);
          break;
        }
        case "REQUEST_INVENTORY_FAILED":
          callback([]);
          break;
      }
    },    
    getAllInventory(callback) {
      var lg = "";
      let lang = document.documentElement.lang;

      if (lang && lang == "fr-CA")
        lg = "_fr";

      axios.get("/wp-content/uploads/data/inventory" +lg +".json?v=" +EventBus.getJSONTimestamp(5, "Inventory"))
      .then((response) => {
        callback(response.data.vehicles);
      })
      .catch((error) => {
        callback([]);
      });
    },
    getUnfilteredInventory(vueThis) {
      return new Promise(function (resolve, reject) {
        sessionStorage.removeItem("unfilteredInventory");
        
        let existsLastUpdate = sessionStorage.getItem("lastUpdateInventoryJSON");
        let needsUpdate = EventBus.needsUpdateJSONTimestamp(5, "Inventory");

        let lang = document.documentElement.lang;
        var lg = "";

        if (lang && lang == "fr-CA") {
          lg = "_fr";
          sessionStorage.setItem("lbxLang", lang);
        } else if (lang && lang == "en-CA") {
          sessionStorage.setItem("lbxLang", lang);
        }

        vueThis
          .checkIndexedDBExists("lbx-inventory", "inventory")
          .then((response) => {
            if (!response || needsUpdate || !existsLastUpdate) {
              console.warn("LBX: Inv has no response or 5 mins has passed or no lastUpdateInventoryJSON");

              axios.get("/wp-content/uploads/data/inventory" +lg +".json?v=" +EventBus.getJSONTimestamp(5, "Inventory"))
                .then((response) => {
                  vueThis
                    .storeInventoryData(response.data.vehicles)
                    .then(() => {
                      resolve(response.data.vehicles);
                    })
                    .catch((error) => {
                      resolve(response.data.vehicles);
                    });
                })
                .catch((error) => {
                  reject();
                });
            } else {
              console.warn("LBX: Inv has response or 5 mins has not passed");

              vueThis
                .getInventoryData()
                .then((response) => {
                  console.warn("LBX: Inv has response or 5 mins has not passed but getInventoryData");
                  resolve(response);
                })
                .catch((error) => {
                  console.warn("LBX: Inv has response or 5 mins has not passed but error on getInventoryData");
                  reject();
                });
            }
          });

        //}
      });
    },
    isUnfilteredInventoryOnSessionStorage(){
        if(sessionStorage.getItem('unfilteredInventory'))
            return true;
        else
            return false;
    },
    isLangOnSessionStorage(){
        if(sessionStorage.getItem('lbxLang'))
            return true;
        else
            return false;
    },
    storeUnfilteredInventoryOnSessionStorage(inventory){
      var inventoryString = JSON.stringify(inventory);
      try {
        sessionStorage.setItem("unfilteredInventory", inventoryString);
      } catch (e) {
        console.log("Error saving to sessionStorage: " + e);
      }
    },
    getUnfilteredInventoryFromSessionStorage(){
        if(this.isUnfilteredInventoryOnSessionStorage()){
            return JSON.parse(sessionStorage.getItem('unfilteredInventory'));
        }else{
            return [];
        }
    },
    getLangFromSessionStorage(){
        if(this.isLangOnSessionStorage()){
            return sessionStorage.getItem('lbxLang');
        }else{
            return false;
        }
    },
    initializeIndexedDB() {
      return new Promise((resolve, reject) => {
        const request = indexedDB.open("lbx-inventory", 2);

        request.onupgradeneeded = (event) => {
          const db = event.target.result;
          db.createObjectStore("inventory", { keyPath: "id" });
        };

        request.onsuccess = (event) => {
          const db = event.target.result;
          resolve(db);
        };

        request.onerror = (event) => {
          reject(event.target.error);
        };
      });
    },
    storeInventoryData(data) {
      return new Promise((resolve, reject) => {
        localStorage.removeItem("lbx_setPayments");

        this.initializeIndexedDB()
          .then((db) => {
            const transaction = db.transaction("inventory", "readwrite");
            const store = transaction.objectStore("inventory");

            transaction.oncomplete = () => {
              resolve();
            };

            transaction.onerror = (event) => {
              reject(event.target.error);
            };

            // Limpiar datos antiguos del inventario
            store.clear();

            data.forEach((vehicle) => {
              store.add(vehicle);
            });
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getInventoryData() {
      return new Promise((resolve, reject) => {
        this.initializeIndexedDB()
          .then((db) => {
            const transaction = db.transaction("inventory", "readonly");
            const store = transaction.objectStore("inventory");
            const request = store.getAll();

            request.onsuccess = (event) => {
              resolve(event.target.result);
            };

            request.onerror = (event) => {
              reject(event.target.error);
            };
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    checkIndexedDBExists(dbName, storeName) {
      return new Promise((resolve, reject) => {
        const request = indexedDB.open(dbName);

        request.onsuccess = (event) => {
          const db = event.target.result;
          const objectStoreNames = db.objectStoreNames;

          if (objectStoreNames.contains(storeName)) {
            db.close();
            resolve(true);
          } else {
            db.close();
            resolve(false);
          }
        };

        request.onerror = () => {
          resolve(false);
        };

        request.onupgradeneeded = () => {
          resolve(false);
        };

        request.onblocked = () => {
          reject(
            new Error("La base de datos está bloqueada por otra transacción")
          );
        };
      });
    },
    sendRemainingCallbacks(inventory) {
      this.requestInventoryCallbacks.forEach((cb) => {
        this.inventory = inventory;
        this.options = cb.gutembergOptions;
        this.gutembergOptionsFiltering();
        cb.callback(this.inventory);
      });
    },
    checkValidCDN(url){
      if(url){
        let cdns =  ['cardealerstg.blob.core.windows.net', 'dealerphotocdn.azureedge.net', 'dealerphoto.blob.core.windows.net', 'vehicleimages.leadboxhq.com'];
        for (var i = 0; i < cdns.length; i++) {
          if (url.toLowerCase().indexOf(cdns[i]) !== -1) {
            return true;
          }
        }
        return false;
      }else
        return false;
    },
    gutembergOptionsFiltering() {
      this.filterVehicles();
      this.sortInventory({ field: this.options.sort_by, order: this.options.sort_by_condition });
      this.limit();
    },
    limit() {
      if (this.options.limit > 0)
        this.inventory = this.inventory.slice(0, this.options.limit)
    },
    sortInventory(payload) {
      if(payload.field === 'make (custom)') {

        let uniqueMakes = this.inventory.map(item => item.make).filter((value, index, self) => self.indexOf(value) === index);
        let makesOrder = this.options.sort_makes;
        
        makesOrder = this.arrayUnique(makesOrder.concat(uniqueMakes)); 
        makesOrder = makesOrder.map(element => { return element.toLowerCase(); });

        const SortingPrioritize = (PrioList = []) =>
        {
            return ({make:a},{make:b}) => {
            let aPos = PrioList.indexOf(a.toLowerCase()), bPos = PrioList.indexOf(b.toLowerCase());
            return (aPos>-1 && bPos>-1) ? aPos - bPos 
                            : (aPos>-1) ? -1 
                            : (bPos>-1) ? +1 
                            : a-b
            } 
        }

        this.inventory.sort( SortingPrioritize(makesOrder) );

      } else if(payload.field === 'location (custom)'){

        let uniqueLocations = this.inventory.map(item => item.location).filter((value, index, self) => self.indexOf(value) === index);
        let locationsOrder = this.options.sort_locations;
        
        locationsOrder = this.arrayUnique(locationsOrder.concat(uniqueLocations)); 
        locationsOrder = locationsOrder.map(element => { return element.toLowerCase(); });
        if (payload.order == 'desc') {
          locationsOrder = locationsOrder.reverse();
        }
        const SortingPrioritizeLocation = (PrioList = []) =>
        {
            return ({location:a},{location:b}) => {
            let aPos = PrioList.indexOf(a.toLowerCase()), bPos = PrioList.indexOf(b.toLowerCase());
            return (aPos>-1 && bPos>-1) ? aPos - bPos 
                            : (aPos>-1) ? -1 
                            : (bPos>-1) ? +1 
                            : a-b
            } 
        }

        this.inventory.sort( SortingPrioritizeLocation(locationsOrder) );        

      } else if(payload.field === 'model (custom)'){

        let uniqueModels = this.inventory.map(item => item.model).filter((value, index, self) => self.indexOf(value) === index);
        let modelsOrder = this.options.sort_models;
        
        modelsOrder = this.arrayUnique(modelsOrder.concat(uniqueModels)); 
        modelsOrder = modelsOrder.map(element => { return element.toLowerCase(); });
        if (payload.order == 'desc') {
          modelsOrder = modelsOrder.reverse();
        }
        const SortingPrioritizeModel = (PrioList = []) =>
        {
            return ({model:a},{model:b}) => {
            let aPos = PrioList.indexOf(a.toLowerCase()), bPos = PrioList.indexOf(b.toLowerCase());
            return (aPos>-1 && bPos>-1) ? aPos - bPos 
                            : (aPos>-1) ? -1 
                            : (bPos>-1) ? +1 
                            : a-b
            } 
        }

        this.inventory.sort( SortingPrioritizeModel(modelsOrder) );        

      } else if(payload.field === 'trim (custom)'){

        let uniqueTrims = this.inventory.map(item => item.trim).filter((value, index, self) => self.indexOf(value) === index);
        let trimsOrder = this.options.sort_trims;
        
        trimsOrder = this.arrayUnique(trimsOrder.concat(uniqueTrims)); 
        trimsOrder = trimsOrder.map(element => { return element.toLowerCase(); });
        if (payload.order == 'desc') {
          trimsOrder = trimsOrder.reverse();
        }
        const SortingPrioritizeTrim = (PrioList = []) =>
        {
            return ({trim:a},{trim:b}) => {
            let aPos = PrioList.indexOf(a.toLowerCase()), bPos = PrioList.indexOf(b.toLowerCase());
            return (aPos>-1 && bPos>-1) ? aPos - bPos 
                            : (aPos>-1) ? -1 
                            : (bPos>-1) ? +1 
                            : a-b
            } 
        }

        this.inventory.sort( SortingPrioritizeTrim(trimsOrder) );        

      } else if(payload.field === 'stocknumbers'){
        
        this.inventory.sort((a, b) => {
          const validOrders = ['asc', 'desc'];
          let order = (payload && payload.order || 'asc').toLowerCase(); 
      
          if (!validOrders.includes(order)) {
              order = 'asc';
          }
      
          const getStockNumber = (item) => {
              const stockNumber = item && item.stocknumber;
              return stockNumber === undefined || stockNumber === null ? '' : String(stockNumber);
          };
      
          const stockNumberA = getStockNumber(a);
          const stockNumberB = getStockNumber(b);
      
          const compareStockNumbers = () => {
              const numA = Number(stockNumberA);
              const numB = Number(stockNumberB);
      
              if (!isNaN(numA) && !isNaN(numB)) {
                  return (numA - numB) * (order === 'asc' ? 1 : -1);
              } else {
                  return stockNumberA.localeCompare(stockNumberB) * (order === 'asc' ? 1 : -1);
              }
          };
      
          return compareStockNumbers();
        });


        } else if (payload.field === 'totaldiscounts') {
          const groupRank = (v) => {
            const inc = v?.incoming;
            const dem = v?.demo;

            if (inc === false) return 0; // 1ro: incoming false
            if (dem === true)  return 1; // 2do: demo true
            if (inc === true)  return 2; // 3ro: incoming true
            return 3;                    // fallback
          };

          this.inventory.sort((a, b) => {
            const na = Number(a.totaldiscounts);
            const nb = Number(b.totaldiscounts);

            const aVal = Number.isFinite(na) ? na : 0;
            const bVal = Number.isFinite(nb) ? nb : 0;

            const aIsZero = aVal === 0;
            const bIsZero = bVal === 0;

            // --- Comparación principal por totaldiscounts ---
            let cmp;

            if (payload.order === 'desc') {
              // Negativos primero; ceros al final
              if (aIsZero && !bIsZero) return 1;
              if (bIsZero && !aIsZero) return -1;

              // Entre negativos (o ambos no-cero): más negativo primero
              cmp = aVal - bVal; // p.ej., -9000 antes que -3000
              if (cmp !== 0) return cmp;

              // --- Tiebreaker/orden secundario SOLO en desc ---
              const ra = groupRank(a);
              const rb = groupRank(b);
              if (ra !== rb) return ra - rb;

              return 0;
            } else {
              // ASC: negativos primero (menos negativo antes), ceros al final
              if (aIsZero && !bIsZero) return 1;
              if (bIsZero && !aIsZero) return -1;

              // Entre negativos: menos negativo primero (más cerca de 0)
              cmp = bVal - aVal; // p.ej., -1500 antes que -3000
              return cmp;
            }
          });
        } else {
        this.inventory.sort((a, b) => {
          var nameA = a[payload.field]; // ignore upper and lowercase
          var nameB = b[payload.field]; // ignore upper and lowercase
          if (nameA < nameB) {
            if (payload.order == 'asc')
              return -1;
            else
              return 1;
          }
          if (nameA > nameB) {
            if (payload.order == 'asc')
              return 1;
            else
              return -1;
          }
          
          // names must be equal
          return 0;
        });
      }
    },
    arrayUnique(array) {
      var a = array.concat();
      for(var i=0; i<a.length; ++i) {
          for(var j=i+1; j<a.length; ++j) {
              if(a[i] === a[j])
                  a.splice(j--, 1);
          }
      }
  
      return a;
    },
    filterVehicles() {
      var $_vehicles = [];
      var $_stockWildcard = [];
      var $yearrange = this.parse_range(this.options['year'], true);
      var $pricerange = this.parse_range(this.options['price'], true);
      var $carprooflinkrange = this.parse_range(this.options['carprooflink'], true);
      var $mileagerange = this.parse_range(this.options['mileage'], true);
      var $statusrange = this.parse_range(this.options['status']);
      var $makerange = this.parse_range(this.options['make']);
      var $modelrange = this.parse_range(this.options['model']);
      var $trimrange = this.parse_range(this.options['trim']);
      var $locationrange = this.parse_range(this.options['location']);
      var $typerange = this.parse_range(this.options['type']);
      var $stockrange = this.parse_range(this.options['stock']);
      var $tagsrange = this.parse_range(this.options['tags']);
      var $flags = this.parse_range(this.options['flags']);
      var $exclude_tags = this.parse_range(this.options['exclude_tags']);

      $stockrange.forEach(element => {
        if (element.includes("*")) {
          $_stockWildcard.push(element.replace("*", ""));
        }
      });

      Object.values(this.inventory).forEach(vehicle => {
        this.vehicleMatcher.vehicle = vehicle;
        var $is_match = this.vehicleMatcherMatch('year', $yearrange) &&
          this.vehicleMatcherMatch('make', $makerange) &&
          this.vehicleMatcherMatch('model', $modelrange) &&
          this.vehicleMatcherMatch('trim', $trimrange) &&
          this.vehicleMatcherMatch('location', $locationrange) &&
          this.vehicleMatcherMatch('price', $pricerange) &&
          this.vehicleMatcherMatch('mileage', $mileagerange) &&
          this.vehicleMatcherMatch('type', $typerange) &&
          this.vehicleMatcherMatch('condition', $statusrange, 'status') &&
          this.vehicleMatcherMatch('stocknumber', $stockrange, 'stock', $_stockWildcard) &&
          this.vehicleMatcherMatchAny('tags', $tagsrange) &&
          this.vehicleMatcherNoTags($exclude_tags) &&
          this.vehicleMatcherMatchFlags($flags);

        if ($is_match) {
          $_vehicles.push(vehicle);
        }
      })

      this.inventory = $_vehicles;
    },
    parse_range($value, $evaluateHyphen = false) {
      var $range = [];
      if ($value && $value != 'all') {
        if ($evaluateHyphen && $value.indexOf('-') !== -1) {
          $range = $value.split('-');
          $range = this.range($range[1] - $range[0], $range[0]);
        } else if ($value.indexOf(',') !== -1) {
          $range = $value.split(',');
        } else {
          $range = [$value];
        }
      }

      return $range;
    },
    range(size, startAt = 0) {
      var range = [];
      for (var i = 0; i <= size; i++) {
        range.push(startAt.toString() || startAt);
        startAt++;
      }
      return range;
    },
    vehicleMatcherMatch($property, $values, $propertyOptions = null, $stockWildcard = null) {
      $propertyOptions = $propertyOptions || $property;
      var $value = (this.vehicleMatcher.vehicle && this.vehicleMatcher.vehicle[$property]) ? this.vehicleMatcher.vehicle[$property] : "";
      var $findWildcard = false;
      if ($propertyOptions == "stock") {
        if ($stockWildcard) {
          if ($stockWildcard.length > 0) {
              $stockWildcard.forEach(element => {
              if ($value.includes(element)) {
                $findWildcard = true;
              }
            });
          }
        }
      }
      if ($findWildcard == true) {
        return true;
      } else {
        return this.options[$propertyOptions] == 'all' || $values.includes($value.toString() || parseFloat($value));
      }
    },
    vehicleMatcherMatchAny($property, $values, $delimiter = ',', $propertyOptions = null) {

      $propertyOptions = $propertyOptions || $property;

      if (this.options[$propertyOptions] == 'all') {
        return true;
      }
      var $arrayValue = (this.vehicleMatcher.vehicle[$property] || '').split($delimiter);

      for (var i = 0; i < $arrayValue.length; i++) {
        if ($values.includes($arrayValue[i]))
          return true;
      }
      return false;
    },
    vehicleMatcherNoTags($tags) {
      if (($tags.length === 0) || ($tags.length === 1 && $tags[0] == "")) {
        return true;
      }
    
      if (this.vehicleMatcher.vehicle.tags === undefined || this.vehicleMatcher.vehicle.tags === null) {
        return true; 
      }
    
      for (var i = 0; i < $tags.length; i++) {
        if (this.vehicleMatcher.vehicle.tags.indexOf($tags[i]) !== -1) {
          return false; 
        }
      }
    
      return true;
    },
    vehicleMatcherMatchFlags($flags) {
      if ($flags.length === 0) {
        return true;
      }

      if ($flags.length === 1 && $flags[0] == "none") {
        return true;
      }

      var ret = true;

      for (var i = 0; i < $flags.length; i++) {
        if (!this.vehicleMatcher.vehicle[$flags[i]] && $flags[i] != 'excludeincoming' && $flags[i] != 'excludesalepending' && $flags[i] != 'excludedemo' && $flags[i] != 'noprice') {
          ret = false;
        }else if ($flags[i] == 'excludeincoming' && this.vehicleMatcher.vehicle['incoming']) {
          ret = false;
        }else if ($flags[i] == 'excludesalepending' && this.vehicleMatcher.vehicle['salepending']) {
          ret = false;
        }else if ($flags[i] == 'excludedemo' && this.vehicleMatcher.vehicle['demo']) {
          ret = false;
        }else if ($flags[i] == 'noprice' && this.vehicleMatcher.vehicle['price'] > 0) {
          ret = false;
        }
      }

      return ret;
    },
    isEmpty(val) {
      return (val === undefined || val == null || val.length <= 0) ? true : false;
    },
    string_contains_value(text, filter) {
      var array = filter.toLowerCase().split("_");
      var total_words = array.length;
      var vehicle = text.split(' ').map((item) => {
        return item.toLowerCase();
      })
      var total_coincidences = 0;
      array.forEach((item) => {
        var total_i = vehicle.filter((span) => {
          return span.includes(item);
        }).length;

        var total_p = vehicle.filter((span) => {
          return span.replace(/-/g, '').includes(item.replace(/-/, ''));
        }).length;

        if (total_i > 0 || total_p > 0)
          total_coincidences++;
      })

      if (total_words == total_coincidences) {
        return true;
      }
      else {
        return false;
      }
    },
    postFilterInventory(initialInventory, payload) {
      var stockNumber = payload.stockNumber;
      var mileageRange = payload.mileageRange;
      var priceRange = payload.priceRange;
      var carprooflinkRange = payload.carprooflinkRange;
      var paymentRange = payload.paymentRange;
      var paymentFrequency = payload.paymentFrequency.toLowerCase();
      var filterValue = payload.filterValue;
      var selected = payload.selected;
      var dryweightRange = payload.dryweightRange;
      var grossweightRange = payload.grossweightRange;
      var sleepcapacityRange = payload.sleepcapacityRange;

      // Función para normalizar y transformar el estado
      const normalizeStatus = (status) => status.replace(/ /g, '-').replace(/-+/g, '-').toLowerCase();

      // Lista normalizada de estados seleccionados
      const normalizedSelectedStatus = selected.status.map(normalizeStatus);
      
      var filteredInventory = [];
      Object.values(initialInventory).forEach(item => {

        const booleanKeys = ['salepending', 'demo', 'asis', 'certified', 'special'];
        const allowedKeys = [
          'condition', 'stocknumber', 'year', 'make', 'lot', 'model', 
          'location', 'type', 'subtype', 'trim', 'bodystyle', 
          ...booleanKeys,
          'price', 'carprooflink', 'payments', 'mileage', 
          'exteriorcolor', 'dryweight', 'grossweight', 'sleepcapacity', 
          'length', 'productline', 'vin', 'fueltype', 'drivetrain', 'seat'
        ];

        var super_string = allowedKeys
          .map(key => {
            const value = item[key];

            if (booleanKeys.includes(key)) {
              return value === true ? key : '';
            }

            return this.isEmpty(value) ? '' : (key === 'model' ? value + 's' : value);
          })
          .filter(value => value !== '')
          .join(' ');

        // condition
        if (
          item.condition &&
          selected.condition.length > 0 &&
          selected.condition.map((item) => { return item.replace(/ /g, '-').replace(/-+/g, '-').toLowerCase() })
            .indexOf(item.condition.replace(/ /g, '-').replace(/-+/g, '-').toLowerCase()) == -1
        )
          return;
        if (!item.condition && selected.condition.length > 0)
          return;

          
          // year
          if (
          item.year &&
          selected.year.length > 0 &&
          selected.year.indexOf(item.year) == -1
        )
          return;
        if (!item.year && selected.year.length > 0)
        return;
        
        // make
        if (
          item.make &&
          selected.make.length > 0 &&
          selected.make.map((item) => { return item.replace(/ /g, '-').toLowerCase() }).indexOf(item.make.replace(/ /g, '-').toLowerCase()) == -1
        )
        return;
        if (!item.make && selected.make.length > 0)
        return;
        
        // Lot
        if (
            item.lot &&
            selected.lot.length > 0 &&
            selected.lot.map((item) => { return item.replace(/ /g, '-').toLowerCase() }).indexOf(item.lot.replace(/ /g, '-').toLowerCase()) == -1
            )
            return;
            if (!item.lot && selected.lot.length > 0)
            return;
            
            // stock
        if (
          item.stocknumber &&
          selected.stock.length > 0 &&
          selected.stock.map((item) => { return item.replace(/ /g, '-').toLowerCase() }).indexOf(item.stocknumber.replace(/ /g, '-').toLowerCase()) == -1
        )
          return;
          if (!item.stocknumber && selected.stock.length > 0)
          return;
          
          // type
          if (
              item.type &&
              selected.type &&
              selected.type.length > 0 &&
              selected.type.map((item) => { return item.replace(/ /g, '-').replace(/-+/g, '-').toLowerCase() })
              .indexOf(item.type ? item.type.replace(/ /g, '-').replace(/-+/g, '-').toLowerCase() : '') == -1
              )
              return;
              if (!item.type && selected.type && selected.type.length > 0)
                return;
             
              // subtype
        if (
          item.subtype &&
          selected.subtype.length > 0 &&
          selected.subtype.map((item) => { return item.toLowerCase() }).indexOf(item.subtype.toLowerCase()) == -1
        )
        return;
        if (!item.subtype && selected.subtype.length > 0)
        return;
        
        // productline
        if (
          item.productline &&
          selected.productline.length > 0 &&
          selected.productline.map((item) => { return item.toLowerCase() }).indexOf(item.productline.toLowerCase()) == -1
          )
          return;
          if (!item.productline && selected.productline.length > 0)
          return;
          
          // length
          if (
              item["length"] &&
              selected.outsidelength.length > 0 && item.length &&
              selected.outsidelength.map((item) => { return item.toLowerCase() }).indexOf(item["length"].toLowerCase()) == -1
              )
              return;
              if (!item["length"] && selected.outsidelength.length > 0)
              return;
              
              // floorplantags
        if (
          item.floorplantags &&
          selected.floorplan.length > 0
        ) {
          var intersection = selected.floorplan.filter(o => item.floorplantags.includes(o));
          if (intersection.length < selected.floorplan.length)
          return;
        }
        if (!item.floorplantags && selected.floorplan.length > 0)
        return;
        
        // model
        if (
          item.model &&
          selected.model.length > 0 &&
          selected.model.map((item) => { return item.replace(/ /g, '-').replace(/-+/g, '-').toLowerCase() }
          )
            .indexOf(item.model ? item.model.replace(/ /g, '-').replace(/-+/g, '-').toLowerCase() : '') == -1) {
                return;
            }
            if (!item.model && selected.model.length > 0)
            return;
            
            // trim
        if (
          item.trim &&
          selected.trim.length > 0 &&
          selected.trim.map((item) => { return item.replace(/ /g, '-').replace(/-+/g, '-').toLowerCase() })
            .indexOf(item.trim ? item.trim.replace(/ /g, '-').replace(/-+/g, '-').toLowerCase() : '') == -1
        )
          return;
          if (!item.trim && selected.trim.length > 0)
          return;
          
          // exteriorcolor
        if (
          item.exteriorcolor &&
          selected.colour.length > 0 &&
          selected.colour.map((item) => { return item.replace(/ /g, '-').replace(/-+/g, '-').toLowerCase() })
            .indexOf(item.exteriorcolor ? item.exteriorcolor.replace(/ /g, '-').replace(/-+/g, '-').toLowerCase() : '') == -1
        )
          return;
        if (!item.exteriorcolor && selected.colour.length > 0)
          return;
          
          // transmission
        if (
          item.transmission &&
          selected.transmission.length > 0 &&
          selected.transmission.indexOf(item.transmission) == -1
        )
          return;
          if (!item.transmission && selected.transmission.length > 0)
          return;
          
          // drivetrain
          if (
              item.drivetrain &&
              selected.drivetrain &&
              selected.drivetrain.length > 0 &&
              selected.drivetrain.map((item) => { return item.replace(/ /g, '-').replace(/-+/g, '-').toLowerCase() })
              .indexOf(item.drivetrain ? item.drivetrain.replace(/ /g, '-').replace(/-+/g, '-').toLowerCase() : '') == -1
              )
              return;
              if (!item.drivetrain && selected.drivetrain && selected.drivetrain.length > 0)
              return;

        // boxsize
        if (
          item.boxsize &&
          selected.boxsize &&
          selected.boxsize.length > 0 &&
          selected.boxsize.map((item) => { return item.replace(/ /g, '-').replace(/-+/g, '-').toLowerCase() })
          .indexOf(item.boxsize ? item.boxsize.replace(/ /g, '-').replace(/-+/g, '-').toLowerCase() : '') == -1
          )
          return;
          if (!item.boxsize && selected.boxsize.length > 0)
          return;

          // STATUS FILTER ------------------------------       
          if (
            item.incoming &&
            normalizedSelectedStatus.length > 0 &&
            !normalizedSelectedStatus.includes("incoming")
          ) {
            if (!(item.special && normalizedSelectedStatus.includes("special"))) {
              if (!(item.demo && normalizedSelectedStatus.includes("demo"))) {
                if (!(item.salepending && normalizedSelectedStatus.includes("sale-pending"))) {
                  if (!(item.certified && normalizedSelectedStatus.includes("certified"))) {
                    if (!(item.asis && normalizedSelectedStatus.includes("as-is"))) {
                    return;
                    }
                  }
                }
              }
            }
          }

          if (
            !item.incoming &&
            normalizedSelectedStatus.length > 0 &&
            !normalizedSelectedStatus.includes("in-stock")
          ) {
            if (!(item.special && normalizedSelectedStatus.includes("special"))) {
              if (!(item.demo && normalizedSelectedStatus.includes("demo"))) {
                if (!(item.salepending && normalizedSelectedStatus.includes("sale-pending"))) {
                  if (!(item.certified && normalizedSelectedStatus.includes("certified"))) {
                    if (!(item.asis && normalizedSelectedStatus.includes("as-is"))) {
                      return;
                      }
                  }
                }
              }
            }
          }

          if (
            item.special &&
            normalizedSelectedStatus.length > 0 &&
            !normalizedSelectedStatus.includes("special")
          ) {
            if (!(item.incoming && normalizedSelectedStatus.includes("incoming"))) {
              if (!(!item.incoming && normalizedSelectedStatus.includes("in-stock"))) {
                if (!(item.demo && normalizedSelectedStatus.includes("demo"))) {
                  if (!(item.salepending && normalizedSelectedStatus.includes("sale-pending"))) {
                    if (!(item.certified && normalizedSelectedStatus.includes("certified"))) {
                      if (!(item.asis && normalizedSelectedStatus.includes("as-is"))) {
                        return;
                        }
                    }
                  }
                }
              }
            }
          }

          if (
            item.demo &&
            normalizedSelectedStatus.length > 0 &&
            !normalizedSelectedStatus.includes("demo")
          ) {
            if (!(item.incoming && normalizedSelectedStatus.includes("incoming"))) {
              if (!(!item.incoming && normalizedSelectedStatus.includes("in-stock"))) {
                if (!(item.special && normalizedSelectedStatus.includes("special"))) {
                  if (!(item.salepending && normalizedSelectedStatus.includes("sale-pending"))) {
                    if (!(item.certified && normalizedSelectedStatus.includes("certified"))) {
                      if (!(item.asis && normalizedSelectedStatus.includes("as-is"))) {
                        return;
                        }
                    }
                  }
                }
              }
            }
          }

          if (
            item.salepending &&
            normalizedSelectedStatus.length > 0 &&
            !normalizedSelectedStatus.includes("sale-pending")
          ) {
            if (!(item.incoming && normalizedSelectedStatus.includes("incoming"))) {
              if (!(!item.incoming && normalizedSelectedStatus.includes("in-stock"))) {
                if (!(item.special && normalizedSelectedStatus.includes("special"))) {
                  if (!(item.demo && normalizedSelectedStatus.includes("demo"))) {
                    if (!(item.certified && normalizedSelectedStatus.includes("certified"))) {
                      if (!(item.asis && normalizedSelectedStatus.includes("as-is"))) {
                        return;
                        }
                    }
                  }
                }
              }
            }
          }

          if (
            item.certified &&
            normalizedSelectedStatus.length > 0 &&
            !normalizedSelectedStatus.includes("certified")
          ) {
            if (!(item.incoming && normalizedSelectedStatus.includes("incoming"))) {
              if (!(!item.incoming && normalizedSelectedStatus.includes("in-stock"))) {
                if (!(item.special && normalizedSelectedStatus.includes("special"))) {
                  if (!(item.demo && normalizedSelectedStatus.includes("demo"))) {
                    if (!(item.salepending && normalizedSelectedStatus.includes("sale-pending"))) {
                      if (!(item.asis && normalizedSelectedStatus.includes("as-is"))) {
                        return;
                        }
                    }
                  }
                }
              }
            }
          }

          if (
            item.asis &&
            normalizedSelectedStatus.length > 0 &&
            !normalizedSelectedStatus.includes("as-is")
          ) {
            if (!(item.incoming && normalizedSelectedStatus.includes("incoming"))) {
              if (!(!item.incoming && normalizedSelectedStatus.includes("in-stock"))) {
                if (!(item.special && normalizedSelectedStatus.includes("special"))) {
                  if (!(item.demo && normalizedSelectedStatus.includes("demo"))) {
                    if (!(item.salepending && normalizedSelectedStatus.includes("sale-pending"))) {
                      if (!(item.certified && normalizedSelectedStatus.includes("certified"))) {
                        return;
                        }
                    }
                  }
                }
              }
            }
          }

          /* END STATUS FILTER */

        //Salepending
        if (
          item.salepending &&
          selected.salepending.length > 0 &&
          selected.salepending.includes("1") == false
        )
          return;

          if (
          !item.salepending &&
          selected.salepending.length > 0 &&
          selected.salepending.includes("0") == false
        )
        return;

        //Demo
        if (
          item.demo &&
          selected.demo.length > 0 &&
          selected.demo.includes("1") == false
        )
          return;

        if (
          !item.demo &&
          selected.demo.length > 0 &&
          selected.demo.includes("0") == false
        )
        return;

        //As is
        if (
          item.asis &&
          selected.asis.length > 0 &&
          selected.asis.includes("1") == false
        )
          return;

        if (
          !item.asis &&
          selected.asis.length > 0 &&
          selected.asis.includes("0") == false
        )
        return;

        //Certified
        if (
          item.certified &&
          selected.certified.length > 0 &&
          selected.certified.includes("1") == false
        )
          return;

        if (
          !item.certified &&
          selected.certified.length > 0 &&
          selected.certified.includes("0") == false
        )
        return;

        //Special
        if (
          item.special &&
          selected.special.length > 0 &&
          selected.special.includes("1") == false
        )
          return;

        if (
          !item.special &&
          selected.special.length > 0 &&
          selected.special.includes("0") == false
        )
        return;
        
        // engine displacement
        if (
            item.enginedisplacement &&
          selected.enginedisplacement.length > 0 &&
          selected.enginedisplacement.indexOf(item.enginedisplacement.toString()) == -1
        )
          return;
        if (!item.enginedisplacement && selected.enginedisplacement.length > 0)
          return;
          
          // bodystyle
          if (
          item.bodystyle &&
          selected.bodystyle.length > 0 &&
          selected.bodystyle.map((item) => { return item.replace(/ /g, '-').replace(/-+/g, '-').toLowerCase() })
            .indexOf(item.bodystyle ? item.bodystyle.replace(/ /g, '-').replace(/-+/g, '-').toLowerCase() : '') == -1
        )
          return;
          if (!item.bodystyle && selected.bodystyle.length > 0)
          return;

          // fueltype
          if (
            item.fueltype &&
            selected.fueltype &&
            selected.fueltype.length > 0 &&
            selected.fueltype.map((item) => { return item.replace(/ /g, '-').replace(/-+/g, '-').toLowerCase() })
              .indexOf(item.fueltype ? item.fueltype.replace(/ /g, '-').replace(/-+/g, '-').toLowerCase() : '') == -1
          )
            return;
            if (!item.fueltype && selected.fueltype && selected.fueltype.length > 0)
            return;
          
          //  stocknumber
        if (item.stocknumber && stockNumber.length > 0) {
          var stockNExploded = stockNumber.split(',').map(i => i.toLowerCase());

          if (!stockNExploded.includes(item.stocknumber.toLowerCase()))
          return;          
        }
    
        // price
        if (
          item.price &&
          !(item.price >= priceRange[0] && item.price <= priceRange[1])
        )
          return;
        if (
          !item.price &&
          (priceRange[0] > payload.minPrice || priceRange[1] < payload.maxPrice)
          )
          return;

        // mileage
        if (
          item.mileage &&
          !(item.mileage >= mileageRange[0] && item.mileage <= mileageRange[1])
        )
          return;
        if (
          !item.mileage &&
          (mileageRange[0] > payload.minMileage || mileageRange[1] < payload.maxMileage)
        )
          return;

        // carprooflink
        if (item.carprooflink) {
          // Intentar convertir item.carprooflink a un número
          const carprooflinkNumber = Number(item.carprooflink);
        
          // Verificar si la conversión fue exitosa y si está dentro del rango
          if (!isNaN(carprooflinkNumber) &&
              !(carprooflinkNumber >= carprooflinkRange[0] && carprooflinkNumber <= carprooflinkRange[1])) {
            return;
          }
        }
        
        if (
          (!item.carprooflink || item.carprooflink == "") &&
          (carprooflinkRange[0] > payload.minCarprooflink || carprooflinkRange[1] < payload.maxCarprooflink)
          )
            return;  

        // payment
          if (
          item.payments &&
          (item.payments.biweekly != 0 || item.payments.weekly != 0 || item.payments.monthly != 0) &&
          (paymentRange[0] != 0 && paymentRange[1] != 0) &&
          !(item.payments[paymentFrequency] >= paymentRange[0] && item.payments[paymentFrequency] <= paymentRange[1])
        ){
          return;
        }
        if (
          (!item.payments || (item.payments.biweekly == 0 && item.payments.weekly == 0 && item.payments.monthly == 0)) &&
          (paymentRange[0] != 0 && paymentRange[1] != 0) &&
          (paymentRange[0] > payload.minPayment || paymentRange[1] < payload.maxPayment)
          ){
            return; 
          }
        

        // dryweight
        if (
          item.dryweight &&
          !(item && item.dryweight != undefined && item.dryweight != null && parseInt(item.dryweight) >= parseInt(dryweightRange[0]) && parseInt(item.dryweight) <= parseInt(dryweightRange[1]))
        )
          return;
        if (
          !item.dryweight &&
          (dryweightRange[0] > payload.minDryweight || dryweightRange[1] < payload.maxDryweight)
        )
          return;

        // grossweight
        if (
          item.grossweight &&
          !(item && item.grossweight != undefined && item.grossweight != null && parseInt(item.grossweight) >= parseInt(grossweightRange[0]) && parseInt(item.grossweight) <= parseInt(grossweightRange[1]))
        )
          return;
        if (
          !item.grossweight &&
          (grossweightRange[0] > payload.minGrossweight || grossweightRange[1] < payload.maxGrossweight)
        )
          return;

        // sleepcapacity
        if (
          item.sleepcapacity &&
          !(item && item.sleepcapacity != undefined && item.sleepcapacity != null && parseInt(item.sleepcapacity) >= parseInt(sleepcapacityRange[0]) && parseInt(item.sleepcapacity) <= parseInt(sleepcapacityRange[1]))
        )
          return;
        if (
          !item.sleepcapacity &&
          (sleepcapacityRange[0] > payload.minSleepcapacity || sleepcapacityRange[1] < payload.maxSleepcapacity)
        )
          return;

        // superstring
        const currentYear = (new Date().getFullYear()+2);
        if (filterValue.length === 4 && !isNaN(filterValue) && (parseInt(filterValue) >= 1950 && parseInt(filterValue) <= currentYear)) {
          if (filterValue.indexOf(item.year) == -1) {
            return;
          }
        } else if (filterValue.length > 0 && !this.string_contains_value(super_string, filterValue.replace(/ /g, '_'))) {
          return;
        }

        // searchablesarray
        if (
          item.searchablesarray &&
          selected.feature.length > 0
        ) {
          var featintersection = selected.feature.filter(o => item.searchablesarray
            .map(sa => sa.replace(/ /g, '-').toLowerCase())
            .includes(o.replace(/ /g, '-').toLowerCase()));
          if (featintersection.length < selected.feature.length)
            return;
        }
        if (!item.searchablesarray && selected.feature.length > 0)
          return;

        // searchables
        if (
          item.searchables &&
          selected.package.length > 0
        ) {
          var searchablesExploded = item.searchables.split(',').map(i => i.toLowerCase());
          var packintersection = selected.package.map(i => i.toLowerCase()).filter(o => searchablesExploded.includes(o));

          if (!packintersection.length)
            return;
          
        }
        if (!item.searchables && selected.package.length > 0)
          return;

        // engine
        if (
          item.engine &&
          selected.engine.length > 0 &&
          selected.engine.map((item) => { return item.replace(/ /g, '-').replace(/-+/g, '-').toLowerCase() })
          .indexOf(item.engine ? item.engine.replace(/ /g, '-').replace(/-+/g, '-').toLowerCase() : '') == -1
          )
        {
          return;
        }
        if (!item.engine && selected.engine.length > 0)
          return;
          
        // location
        if (
          item.location &&
          selected.location.length > 0 &&
          selected.location.indexOf(item.location.toUpperCase()) == -1
        )
          return;
        if (!item.location && selected.location.length > 0)
          return;
    
        // Seat
        if (
          item.seats &&
          selected.seat.length > 0 &&
          selected.seat.indexOf(item.seats.toString()) == -1
        )
          return;
        if (!item.seats && selected.seat.length > 0)
          return;

        filteredInventory.push(item);

      });

      return filteredInventory;
    },
    getJSONTimestamp(minutes, name) {
      let lastTimestamp = sessionStorage.getItem("lastUpdate" + name + "JSON");
      let currentDate = new Date();
      if (lastTimestamp) {
        var lastUpdateDate = new Date(lastTimestamp * 1000);
        let minutesDifference = (currentDate - lastUpdateDate) / (60 * 1000);
        if (minutesDifference <= minutes) {
          return lastUpdateDate;
        } else {
          return currentDate;
        }
      } else {
        return currentDate;
      }
    },
    needsUpdateJSONTimestamp(minutes, name) {
      let lastTimestamp = sessionStorage.getItem("lastUpdate" + name + "JSON");
      let currentDate = new Date();

      if (lastTimestamp) {
        var lastUpdateDate = new Date(lastTimestamp * 1000);
        let minutesDifference = (currentDate - lastUpdateDate) / (60 * 1000);

        console.warn("LBX: Minutes Difference --> ", minutesDifference);
        if (minutesDifference <= minutes) {
          console.warn("LBX: No need to update");
          return false;
        } else {
          console.warn("LBX: Needs to update");
          sessionStorage.setItem("lastUpdate" + name + "JSON",Math.floor(currentDate / 1000));
          return true;
        }
      } else {
        console.warn("LBX: lastUpdate session storage not found");
        sessionStorage.setItem("lastUpdate" + name + "JSON",Math.floor(currentDate / 1000));
        return false;
      }
    },
    maxTermItem(vehicleFinance, vehicleYear, vehicleModel) {
      if (!(vehicleFinance instanceof Array)) return vehicleFinance;
      
      var currentYear = new Date().getFullYear();
      let max = 0;
      let i = 0;
      let z = 0;
      let selected = -1;
    
      if (vehicleFinance != null) {
        if(!vehicleFinance.modelFinancing){
            Object.values(vehicleFinance).forEach(item => {
              if(item.term > max){
                max = item.term;
                selected = i;
              }
              i++;
            })
        }else{
          Object.values(vehicleFinance).forEach((item) => {
            if (item.models) {
              if (
                item.models.toLowerCase().includes(vehicleModel.toLowerCase()) &&
                vehicleYear >= item.startyear &&
                vehicleYear <= item.endyear &&
                !item.isCPO
              ) {
                max = item.term;
                selected = i;
              }
            }
            i++;
          });
      
          if (selected == -1) {
            Object.values(vehicleFinance).forEach((item) => {
              if (
                item &&
                vehicleModel &&
                item.models &&
                !item.isCPO &&
                item.models.toLowerCase().indexOf("all") !== -1
              ) {
                if (parseInt(item.startyear) <= 0 && parseInt(item.endyear) > 0) {
                  if (
                    vehicleYear >= currentYear - Math.abs(item.startyear) &&
                    vehicleYear <= item.endyear
                  ) {
                    max = item.term;
                    selected = z;
                  }
                } else if (
                  parseInt(item.endyear) <= 0 &&
                  parseInt(item.startyear) > 0
                ) {
                  if (
                    vehicleYear >= item.startyear &&
                    vehicleYear <= currentYear - Math.abs(item.endyear)
                  ) {
                    max = item.term;
                    selected = z;
                  }
                } else if (
                  parseInt(item.endyear) <= 0 &&
                  parseInt(item.startyear) <= 0
                ) {
                  if (
                    vehicleYear >= currentYear - Math.abs(item.startyear) &&
                    vehicleYear <= currentYear - Math.abs(item.endyear)
                  ) {
                    max = item.term;
                    selected = z;
                  }
                } else {
                  if (vehicleYear >= item.startyear && vehicleYear <= item.endyear) {
                    max = item.term;
                    selected = z;
                  }
                }
              }
              z++;
            });
          }
        }
      }
      if (selected == -1) return {};
    
      return JSON.parse(JSON.stringify(vehicleFinance[selected]));
    },    
    financeRateCPO(financeCPO,year,model){
      var selected = {};
      var currentYear = new Date().getFullYear();

      if(!this.financeUsedData.modelFinancing){
          Object.values(financeCPO).forEach(item => {
            if(item && model && item.models && item.models.toLowerCase().indexOf(model.toLowerCase()) !== -1){
              if(year >= item.startyear && year <= item.endyear){
                selected = item;
              }
            }
          })
          
          if(Object.keys(selected).length === 0) {
            Object.values(financeCPO).forEach(item => {
              if(item && model && item.models && item.models.toLowerCase().indexOf("other") !== -1){
                if(year >= item.startyear && year <= item.endyear){
                  selected = item;
                }
              }
            })
          }
      }else{
          Object.values(financeCPO).forEach(item => {
              if(item && model && item.models && item.isCPO && item.models.toLowerCase().indexOf(model.toLowerCase()) !== -1){
                if(year >= item.startyear && year <= item.endyear){
                  selected = item;
                }
              }
           });

           if(Object.keys(selected).length === 0) {
              Object.values(financeCPO).forEach(item => {
                if(item && model && item.models && item.isCPO && item.models.toLowerCase().indexOf("all") !== -1){
                  if(parseInt(item.startyear) <= 0 || parseInt(item.endyear) <= 0){
                      if( year >= (currentYear - Math.abs(item.startyear))  && year <= (currentYear - Math.abs(item.endyear)) )
                          selected = item;
                  }else{
                      if(year >= item.startyear && year <= item.endyear)
                          selected = item;
                  }
                }
              })
            }
      }

      return selected;
    },
    calculateFinance(financeArray, frequency, vehiclePrice){
      if (financeArray.term === 0) return 0;
      
      let remainingPrice = vehiclePrice;
      
      if (financeArray.value === 0) return remainingPrice / financeArray.term;
  
      let monthlyPayment = Math.round((((remainingPrice) * (financeArray.value / 1200)) * Math.pow((1 + (financeArray.value / 1200)), financeArray.term)) / (Math.pow((1 + (financeArray.value / 1200)), financeArray.term) - 1) * 100) / 100;
      
      switch (frequency) {
          case 'weekly':
              return Math.round(((monthlyPayment * 12) / 52).toFixed(2));
          case 'bi-weekly':
              return Math.round(((monthlyPayment * 12) / 26).toFixed(2));
          case 'monthly':
          default:
              return Math.round(monthlyPayment.toFixed(2));
      }
    },
    calculatePayment(vehicle, frequency) {

      if(vehicle.condition == 'New'){
        return this.calculateFinance(vehicle.finance, frequency, vehicle.price);
      }else if(vehicle.condition == 'Used' && this.usedFinancing){

        let vehicleFinance = {};
        let finalFinance = {};

          if(this.vehicleCertified && this.usedFinancing && this.usedFinancing.cpo){
            if(!this.usedFinancing.modelFinancing){
              vehicleFinance = this.financeRateCPO(this.usedFinancing.cpo, vehicle.year, vehicle.model);
            }else{
              vehicleFinance = this.financeRateCPO(this.usedFinancing.financeByModel, vehicle.year, vehicle.model);
            }
          }
          else{
            if(this.usedFinancing.specialFinancing && !this.usedFinancing.modelFinancing){
              var currentYear = new Date().getFullYear();
              var yearDiff = currentYear - vehicle.year;

              if(this.usedFinancing.yearsForSubfinance && yearDiff <= this.usedFinancing.yearsForSubfinance)
                  vehicleFinance = this.usedFinancing.subfinance || {term: 0, value: 0};
              else if(this.usedFinancing.yearsForSubfinance && yearDiff > this.usedFinancing.yearsForSubfinance)
                  vehicleFinance = this.usedFinancing.finance || {term: 0, value: 0};
              else
                  vehicleFinance = this.usedFinancing.defaultFinance || {term: 0, value: 0};
            }else if(this.usedFinancing.modelFinancing)
                vehicleFinance = this.usedFinancing.financeByModel || {term: 0, value: 0};
            else
                vehicleFinance = this.usedFinancing || {term: 0, value: 0};
          }

          finalFinance = this.maxTermItem(vehicleFinance, vehicle.year, vehicle.model);
          return this.calculateFinance(finalFinance, frequency, vehicle.price);
        } else{
          return 0;
        }
    },
    setPayments() {
      return new Promise((resolve, reject) => {
        let setPayments = localStorage.getItem("lbx_setPayments");

        if (!setPayments) {
          localStorage.setItem("lbx_setPayments", true);
      
          // Nombre de la base de datos y el almacén de objetos
          const dbName = 'lbx-inventory';
          const storeName = 'inventory';
      
          // Abrir una conexión a la base de datos
          const request = indexedDB.open(dbName, 2);
      
          request.onerror = (event) => {
            reject('Error to open the database');
          };
      
          request.onsuccess = (event) => {
            const db = event.target.result;
      
            // Abrir una transacción en modo de lectura/escritura
            const transaction = db.transaction(storeName, 'readwrite');
            const objectStore = transaction.objectStore(storeName);
      
            // Realizar una solicitud para obtener todos los registros
            const getAllRequest = objectStore.getAll();
      
            getAllRequest.onerror = (event) => {
              console.error('Error to get the data:', event.target.errorCode);
              reject('Error to get the data');
            };
      
            getAllRequest.onsuccess = (event) => {
              const data = event.target.result;
      
              // Recorrer y modificar los datos directamente en IndexedDB
              data.forEach(item => {
                item.payments = {
                  weekly: this.calculatePayment(item, 'weekly'),
                  biweekly: this.calculatePayment(item, 'bi-weekly'),
                  monthly: this.calculatePayment(item, 'monthly')
                };
      
                // Actualizar cada item en el almacén de objetos
                const updateRequest = objectStore.put(item);
      
                updateRequest.onerror = (event) => {
                  console.error('Error to update the data:', event.target.errorCode);
                  reject('Error to update the data');
                };
      
                updateRequest.onsuccess = (event) => {
                  // re-escribe el json por el nuevo
                  //this.saveInventoryJson(data);
                };
              });
      
              // Esperar hasta que la transacción se complete
              transaction.oncomplete = () => {
                resolve(data);
              };
            };
          };
        }else {
          resolve(false);
        }
      });
    },        
  },
  mounted() {},
  watch: {}
});
export default EventBus;